module.exports = __webpack_public_path__ + "static/img/bus-center-btn.6c00e84d.png";